import { NgModule } from '@angular/core';
import { NgrxDialogCloseDirective } from './ngrx-dialog-close.directive';

@NgModule({
  declarations: [ NgrxDialogCloseDirective ],
  exports: [ NgrxDialogCloseDirective ]
})
export class NgrxDialogCloseModule {
}
